import SpaBooking2b from "./spaBooking2b";
import React, { useEffect } from "react";
import SpaBooking2a from "./spaBooking2a";
import { useState } from "react";



function Spabooking2(props) {


  return (

    (props.currentPage == 2.1) ?
      <SpaBooking2a
        spaLocationId={props.spaLocationId}
        spaData={props.spaData}
        setIsAnyPrevReservForAnyLocation={props.setIsAnyPrevReservForAnyLocation}
        updateReservation={async (reversationDetails) => {
         await props.handleReservationUpdateNextToScreen3(reversationDetails)
        }}

        deprecatedAddonList={props.deprecatedAddonList}
        showDeprecatedAddonWarning={props.showDeprecatedAddonWarning}
        shouldProceedOnDeprecatedAddonsWarning={props.shouldProceedOnDeprecatedAddonsWarning}


        cachedApiDataStore={props.cachedApiDataStore}
        setCachedApiDataStore={props.setCachedApiDataStore}
        next={props.nextToScreen2_2} /> :
      <SpaBooking2b
        spaLocationId={props.spaLocationId}
        serviceGroupData={props.serviceGroupData}
        next={props.nextToScreen3}
        selectedService={props.selectedService}
        goBack={props.goBack} />

  )



}
export default Spabooking2;